import { makeStyles } from "@fluentui/react-components";

export const useSuggestionListStyles = makeStyles({
  placeholder: {
    display: "flex",
    flexDirection: "row",
    justifyItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    width: "100%",
    textAlign: "center",
    overflow: "hidden",
  },
  placeholderText: {
    fontWeight: "normal",
  },
  virtuoso: {
    width: "100%",
  },
  spinnerContainer: {
    position: "absolute",
    right: "0px",
    zIndex: 999,
    minWidth: "100vw",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    overflow: "hidden",
  },
  spinnerPosition: {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
});
